import React, { useState, useEffect } from 'react';

import { Route } from "react-router-dom";

import UIkit from 'uikit';
import MDUIkit from 'md-uikit';
import { Link, useLocation } from 'react-router-dom';

import Billing from './components/financial_billing';


import UserActions from '../../providers/user/user.actions';
import { config, settings } from '../../settings.js';

const Products = () => {
    let location = useLocation();
    const language_settings = settings.language.data.admin;
    const user = UserActions();

    const [tabsNames, setTabsNames] = useState([{
        title: language_settings.pages["billing"].page_name[user.currentUser.language],
        url: "/admin/financials/billing"
    }]);

    useEffect(() => {
        console.log(location);
        MDUIkit.components();
    }, []);
    return (
        <>
            <div className={`content-before`}></div>
            <div data-uk-grid>
                <div className="uk-width-1-1@m" >
                    <ul className="uk-navbar-nav">
                        {tabsNames && tabsNames.map(item => (
                            <li>
                                <Link to={item.url}>
                                    {location.pathname == item.url ?
                                        <h4 className={`${settings.colors.primary_text}`} >{item.title}</h4>
                                        :
                                        <h4 className={`${settings.colors.primary_text}`} style={{opacity: "0.5"}} >{item.title}</h4>
                                    }
                                </Link>
                            </li>
                        ))}
                    </ul>

                    <Route exact path='/admin/financials/billing' component={Billing} />
                </div>
            </div>
        </>
    );
}
export default Products;